/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchContext = {
    /**
     * handle context input
     */
    handleContextInput() {
        const searchCtx = {
            units: [{
                searchUnitId: "search-bar",
                queryTypes: ["products"],
                phrase: this.queryPhrase,
                currentPage: 1,
                pageSize: this.topSearchPageSize,
                filter: this.filterOptions,
                sort: this.sortOptions,
                searchRequestId: this.searchRequestId
            }]
        };

        window.magentoStorefrontEvents.context.setSearchInput(searchCtx);
        window.magentoStorefrontEvents.publish.searchRequestSent("search-bar");
    },
    /**
     * handle context results
     *
     * @param result
     * @param before
     * @param after
     */
    handleContextResults(result, before, after) {
        const formattedProductItems = this.formatContextProductItems(result.productSearch.items, this.placeholderImage);
        const formattedSuggestions = this.formatContextSuggestions(result.productSearch.suggestions);
        const formattedFacets = this.formatContextFacets(result.productSearch.facets);

        const searchCtxUpdated = {
            units: [{
                searchUnitId: "search-bar",
                searchRequestId: this.searchRequestId,
                executionTime: after - before,
                products: formattedProductItems,
                categories: [],
                suggestions: formattedSuggestions,
                page: result.productSearch.page_info.current_page,
                perPage: result.productSearch.page_info.page_size,
                facets: formattedFacets
            }]
        };

        window.magentoStorefrontEvents.context.setSearchResults(searchCtxUpdated);
        window.magentoStorefrontEvents.publish.searchResponseReceived("search-bar");
    },
}

export default topSearchContext;
